import { createAsyncThunk } from "@reduxjs/toolkit";
import { Dispatch, SetStateAction } from "react";

import { CopyEventBlockService } from "Bands/services/CopyEventBlockService";
import { BAND_ACTIONS } from "Bands/types";

export const dispatchCopyEventBlocks = (
  dispatch: Dispatch<any>,
  eventIds: string[],
  eventBlockIds: string[],
  includeRsvpUsers?: boolean,
  setCompletedRequests?: Dispatch<SetStateAction<string[] | undefined>>,
  setFailedRequests?: Dispatch<SetStateAction<string[] | undefined>>,
  setIsLoading?: Dispatch<SetStateAction<boolean>>
) =>
  dispatch(
    copyEventBlocks({
      eventIds,
      eventBlockIds,
      includeRsvpUsers,
      setCompletedRequests,
      setFailedRequests,
      setIsLoading,
    })
  );

export const copyEventBlocks = createAsyncThunk(
  BAND_ACTIONS.copyEventBlocks,
  async (
    props: {
      eventIds: string[];
      eventBlockIds: string[];
      includeRsvpUsers?: boolean;
      setCompletedRequests?: Dispatch<SetStateAction<string[] | undefined>>;
      setFailedRequests?: Dispatch<SetStateAction<string[] | undefined>>;
      setIsLoading?: Dispatch<SetStateAction<boolean>>;
    },
    { rejectWithValue }
  ) => {
    try {
      props.setIsLoading?.(true);

      const results = await Promise.allSettled(
        props.eventIds.map(async (eventId) => {
          try {
            const data = await CopyEventBlockService.copyEventBlocks(
              eventId,
              props.eventBlockIds,
              props.includeRsvpUsers
            );

            props.setCompletedRequests?.((prev) =>
              prev ? [...prev, eventId] : [eventId]
            );

            const id = Object.values(
              data.importEventBlocksResponse as object
            )[0].attributes?.eventBlocks?.[0]?.data?.id;

            return { id };
          } catch (error) {
            props.setFailedRequests?.((prev) =>
              prev ? [...prev, eventId] : [eventId]
            );
            // eslint-disable-next-line
            throw { eventId, error };
          }
        })
      );

      const errors = results
        .filter(
          (result): result is PromiseRejectedResult =>
            result.status === "rejected"
        )
        .map((result) => result.reason.eventId);

      if (errors.length > 0) {
        props.setIsLoading?.(false);
        return rejectWithValue(errors);
      }

      const successfulResult = results.find(
        (result): result is PromiseFulfilledResult<{ id: string }> =>
          result.status === "fulfilled"
      );

      props.setIsLoading?.(false);

      return successfulResult?.value;
    } catch (error) {
      props.setIsLoading?.(false);
      return rejectWithValue(error);
    }
  }
);
